import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=5a6716d7"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"
import style0 from "./Preloader.vue?vue&type=style&index=0&id=5a6716d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports